import React from "react";
import { Button } from "reactstrap";
import { FaFolderOpen } from "react-icons/fa";

const BrokerEmptyState = ({
  actionLabel,
  children,
  description,
  icon: Icon = FaFolderOpen,
  onAction,
  onSecondaryAction,
  secondaryLabel,
  title,
}) => (
  <div className="broker-empty-illustration">
    <span className="broker-empty-illustration__icon" aria-hidden="true">
      <Icon />
    </span>
    <div className="broker-empty-illustration__body">
      {title ? <h3>{title}</h3> : null}
      {description ? <p>{description}</p> : null}
      {children}
    </div>
    {(actionLabel || secondaryLabel) ? (
      <div className="broker-empty-illustration__actions">
        {secondaryLabel && onSecondaryAction ? (
          <Button color="light" type="button" onClick={onSecondaryAction}>{secondaryLabel}</Button>
        ) : null}
        {actionLabel && onAction ? (
          <Button color="primary" type="button" onClick={onAction}>{actionLabel}</Button>
        ) : null}
      </div>
    ) : null}
  </div>
);

export default BrokerEmptyState;
